import { ITemplateSpecialPromo } from '../../../repositories/developer-card/entities/template_special_promo/TemplateSpecialPromo';
import type { IApplicationState } from '../../../types/redux';

import { getDeveloper } from '../getDeveloper';

export function getTemplateSpecialPromo(state: IApplicationState): ITemplateSpecialPromo | null {
  return getDeveloper(state).templateSpecialPromo;
}
